// extracted by mini-css-extract-plugin
module.exports = {"main":"Signup_main__iKmhc","hero":"Signup_hero__1fxZP","title":"Signup_title__1mL1d","text":"Signup_text__DddtC","link":"Signup_link__39UOi"};